// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M8.5 3V13M11.5 3V13',
  'M13 3H6.5C4.57 3 3 4.57 3 6.5C3 8.43 4.57 10 6.5 10H8.5',
];
